import { RouteConfig } from 'vue-router'
import i18n from '@/i18n'

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'home',
        meta: { title: i18n.t('integration') },
        component: () => import('@/modules/home/views/Home.vue')
    }
]

export default routes
